module.exports = __webpack_public_path__ + "img/mobilepropertyBanner.d8e59c26.png";